import { Outlet } from 'react-router-dom'
import { KemyoonLogo } from '@/components/KemyoonLogo'

export function PublicLayout() {
  return (
    <div className="min-h-[100dvh] overflow-y-auto bg-white px-5 py-6 flex flex-col items-center">
      <div className="mb-4 shrink-0">
        <KemyoonLogo size="lg" />
      </div>
      <div className="w-full max-w-sm">
        <Outlet />
      </div>
    </div>
  )
}
